import { component } from 'picoapp'
import choozy from 'choozy'
import dcx from 'dcx'
import { createFocusTrap } from 'focus-trap'
import { qsa, on } from 'martha'
import squeezebox from '../lib/squeezebox'

export default component((node, ctx) => {
  const { toggle, topBun, patty, bottomBun, menu, submenu } = choozy(node)

  const topBunCx = dcx(topBun)
  const pattyCx = dcx(patty)
  const bottomBunCx = dcx(bottomBun)
  const menuCx = dcx(menu)

  const trap = createFocusTrap(node, {
    escapeDeactivates: true,
    onDeactivate() {
      ctx.hydrate({ isMobileMenuOpen: false })()
    },
  })

  const accordion = squeezebox(submenu, { collapsible: true, defaultIndex: 0 })

  accordion.on('expand', ({ panel }) => {
    const links = qsa('a', panel)

    links.forEach((link) => {
      link.removeAttribute('tabindex')
    })
  })

  accordion.on('collapsed', ({ panel }) => {
    const links = qsa('a', panel)

    links.forEach((link) => {
      link.setAttribute('tabindex', '-1')
    })
  })

  accordion.mount()

  on(toggle, 'click', () => {
    ctx.hydrate({ isMobileMenuOpen: !ctx.getState().isMobileMenuOpen })()
  })

  ctx.on('isMobileMenuOpen', ({ isMobileMenuOpen }) => {
    trap[isMobileMenuOpen ? 'activate' : 'deactivate']()

    topBunCx({
      'transform rotate-45 translate-y-9': isMobileMenuOpen,
    })

    pattyCx({
      'opacity-0': isMobileMenuOpen,
    })

    bottomBunCx({
      'transform -rotate-45 -translate-y-9': isMobileMenuOpen,
    })

    menuCx({
      'opacity-0 pointer-events-none': !isMobileMenuOpen,
      'opacity-100': isMobileMenuOpen,
    })
  })
})
